import React, { useCallback } from 'react';
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Button, useColorModeValue } from '@chakra-ui/react';
import { t } from 'i18next';

import { useAppVisibility } from 'clipsal-cortex-utils/src/hooks/use-app-visibility';

import { useInvalidateMeterQuery } from '../../../../features/site/live-data/liveDataApi';

type SenseLiveDataErrorAlertProps = {
  isLoading: boolean;
};

export function SenseLiveDataErrorAlert({ isLoading }: SenseLiveDataErrorAlertProps) {
  const linkColor = useColorModeValue('schneiderSkyBlue.600', 'schneiderSkyBlue.200');
  const invalidateMeterQuery = useInvalidateMeterQuery();

  const handleRetry = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    invalidateMeterQuery();
  };

  // Auto retry for the user when they see this error
  const handleAppVisibilityChange = useCallback((isVisible: boolean) => {
    if (isVisible) {
      invalidateMeterQuery();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useAppVisibility(handleAppVisibilityChange);

  return (
    <Box pb={2} px={3}>
      <Alert status="error" data-testid="error-alert">
        <AlertIcon />
        <AlertTitle>{t('Widgets.Live Power.unable to connect to sem')}</AlertTitle>
        <AlertDescription>
          <Button
            onClick={handleRetry}
            variant={'ghost'}
            data-testid="retry-connection"
            color={linkColor}
            isLoading={isLoading}
          >
            {t('Common.retry')}
          </Button>
        </AlertDescription>
      </Alert>
    </Box>
  );
}
